import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OpenAiResponse, OpenAiStates, PDFData } from 'src/interfaces';

const initialState: OpenAiStates = {
    loading: false,
    textQuery: '',
    threadFocus: false,
    openAIResponse: [],
    openAIPDFResponse: [],
    pdfData: null,
};

export const openAiSlice = createSlice({
    name: 'open_ai',
    initialState,
    reducers: {
        setLoading: (state: OpenAiStates, action: PayloadAction<boolean>) => { state.loading = action.payload },
        setTextQuery: (state: OpenAiStates, action: PayloadAction<string | null>) => { state.textQuery = action.payload },
        setThreadFocus: (state: OpenAiStates, action: PayloadAction<boolean>) => { state.threadFocus = action.payload },
        setOpenAIResponse: (state: OpenAiStates, action: PayloadAction<OpenAiResponse[] | ((prev: OpenAiResponse[]) => OpenAiResponse[])>) => {
            if (typeof action.payload === 'function') {
                state.openAIResponse = action.payload(state.openAIResponse);
            } else {
                state.openAIResponse = action.payload;
            }
        },
        setOpenAIPDFResponse: (state: OpenAiStates, action: PayloadAction<OpenAiResponse[] | ((prev: OpenAiResponse[]) => OpenAiResponse[])>) => {
            if (typeof action.payload === 'function') {
                state.openAIPDFResponse = action.payload(state.openAIPDFResponse);
            } else {
                state.openAIPDFResponse = action.payload;
            }
        },
        setPdfData: (state: OpenAiStates, action: PayloadAction<PDFData | null>) => { state.pdfData = action.payload },
    },
});

export const { setLoading, setTextQuery, setThreadFocus, setOpenAIResponse, setOpenAIPDFResponse, setPdfData } = openAiSlice.actions;

export default openAiSlice.reducer;